/**
 * Show modal with error. Use the following code in the body tag of the layout page
 *
 * <body {!! count($errors) > 0 ? ' data-modal="' . old('modal_name') . '"' : '' !!}>
 */
(() => {
    $(document).ready(function () {
        const modalName = $('body').attr('data-modal');
        if (modalName !== null) {
            $('#' + modalName).modal('show');
        }
    });
})();
